import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import InviteTherapistModal from '../InviteTherapistModal';
import { trackClickEvent } from '../../mixpanel';
import { useAuth } from '../../contexts/Auth';

const InviteCard = () => {
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const { permissions } = useAuth();

  const handleInvite = () => {
    trackClickEvent('Clicked Invite', {
      page: 'Homepage',
      component: 'Invite Card',
      button: 'Send Invite'
    });
    setInviteModalOpen(true);
  };

  const handleCloseModal = () => {
    setInviteModalOpen(false);
  };

  return (
    <Paper
      sx={{
        p: 2,
        boxShadow: 'none',
        borderColor: 'border.main',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Typography variant="body1" color="text.primary" fontWeight={700}>
        Invite Your Trusted Colleagues
      </Typography>
      <Button
        variant="contained"
        onClick={handleInvite}
        sx={{
          alignSelf: 'center',
          width: '100%',
          borderRadius: 5,
          backgroundColor: 'primary.main2',
          '&:hover': {
            backgroundColor: 'primary.dark2',
          },
        }}
        disabled={!permissions?.invite_link}
      >
        Send Invite
      </Button>
      <InviteTherapistModal
        open={inviteModalOpen}
        onClose={handleCloseModal}
      />
    </Paper>
  );
};

export default InviteCard;